import i18n from '../i18n';

export default {
  titles: {
    '': i18n.t('labels.personTitles.noTitle'),
    [i18n.t('labels.personTitles.master')]: i18n.t('labels.personTitles.master'),
    [i18n.t('labels.personTitles.miss')]: i18n.t('labels.personTitles.miss'),
    [i18n.t('labels.personTitles.mr')]: i18n.t('labels.personTitles.mr'),
    [i18n.t('labels.personTitles.mrs')]: i18n.t('labels.personTitles.mrs'),
    [i18n.t('labels.personTitles.ms')]: i18n.t('labels.personTitles.ms'),
  },
};
